export function canUseFirebaseEmulators(hostname: string, explicitlyEnabled: boolean) {
  if (!explicitlyEnabled) return false;

  const normalizedHostname = hostname.trim().toLowerCase();
  return normalizedHostname === "localhost"
    || normalizedHostname === "127.0.0.1"
    || normalizedHostname === "::1"
    || normalizedHostname.endsWith(".localhost");
}
